const RedirectMail = () => {
    return(
        <div className="redirect-mail xl:mt-64 xl:mb-32">
            <p>Votre mail a bien été envoyé. Nous vous recontacerons dans les plus brefs delais.</p>
            <a href="/" className="btn-arrow">Retourner a l'accueil</a>
        </div>
    )
}

export default RedirectMail